export type ArcGISAuthenticationPlan =
    | { kind: 'server-token' }
    | { kind: 'portal-token'; tokenUrl: string }
    | { kind: 'token-exchange'; tokenUrl: string };

const ARCGIS_ONLINE_PORTAL_HOST = /^(?:www|[a-z0-9-]+\.maps)\.arcgis\.com$/;
const ARCGIS_PORTAL_TOKEN_PATH = /^\/sharing\/(?:rest\/)?generateToken\/?$/i;
const ARCGIS_MAP_SERVICE_PATH = /\/rest\/services\/.+\/(?:MapServer|FeatureServer)(?:\/\d+)?\/?$/i;

function parseHttpsUrl(value: string): URL | null {
    try {
        const url = new URL(value);
        if (url.protocol !== 'https:' || url.port || url.username || url.password) {
            return null;
        }
        return url;
    } catch {
        return null;
    }
}

function isProductionArcGISOnlineService(url: URL): boolean {
    if (!url.hostname.endsWith('.arcgis.com') || !ARCGIS_MAP_SERVICE_PATH.test(url.pathname)) {
        return false;
    }

    const domain = url.hostname.split('.').at(-3);
    return !!domain && !domain.includes('dev') && !domain.includes('qa');
}

export function resolveArcGISAuthentication(
    serviceUrl: string,
    tokenUrl: string | null | undefined,
): ArcGISAuthenticationPlan {
    if (!tokenUrl) {
        return { kind: 'server-token' };
    }

    const issuer = parseHttpsUrl(tokenUrl);
    const service = parseHttpsUrl(serviceUrl);
    if (
        issuer &&
        service &&
        ARCGIS_ONLINE_PORTAL_HOST.test(issuer.hostname) &&
        ARCGIS_PORTAL_TOKEN_PATH.test(issuer.pathname) &&
        !issuer.search &&
        !issuer.hash &&
        isProductionArcGISOnlineService(service)
    ) {
        return { kind: 'portal-token', tokenUrl };
    }

    return { kind: 'token-exchange', tokenUrl };
}
